let title = ' | Gestor - Comercial Ivaiporã'

const logistica = {
    path: '/logistica',
    props: true,
    component: () => import('@/Components/Logistica/LogisticaContainer.vue'),
    children: [
        {
            path: '',
            name: 'DashboardLogistica',
            component: () => import('@/Components/Logistica/LogisticaDashboard.vue'),
            meta: {
                title: 'Logística' + title,
                permission: 'logistica_menu_dash_lotes',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Acompanhamento de Lotes',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/filial',
                    }
                ]
            }
        },
        {
            path: 'conferencia-remessa',
            name: 'LogisticaLista',
            component: () => import('@/Components/Logistica/LogisticaConferenciaRemessa.vue'),
            meta: {
                title: 'Logística' + title,
                permission: 'logistica_menu_dash_lotes',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Filiais',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/filial',
                    }
                ]
            }
        },
    ]
}

export default logistica